import { useEffect, useState } from "react";
import { api, Role, UserDTO } from "../api";
import { useAuth } from "../auth";

const ROLES: Role[] = ["viewer", "contributor", "editor", "admin"];

function fmt(ts: number | null) {
  return ts ? new Date(ts * 1000).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "never";
}

export default function AdminUsers() {
  const { me } = useAuth();
  const [users, setUsers] = useState<UserDTO[] | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState<string | null>(null);

  const load = () => api.listUsers().then(setUsers).catch((e) => setErr(e.message));
  useEffect(() => {
    load();
  }, []);

  const change = async (u: UserDTO, role: Role) => {
    if (role === u.role) return;
    setBusy(u.sub);
    setErr(null);
    try {
      await api.setUserRole(u.sub, role);
      setUsers((prev) => (prev ? prev.map((x) => (x.sub === u.sub ? { ...x, role } : x)) : prev));
    } catch (e: any) {
      setErr(e.message);
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="page-wrap">
      <h1 style={{ fontFamily: "'Cinzel',serif", fontWeight: 700, fontSize: 30, margin: "0 0 8px" }}>Members</h1>
      <p className="mono" style={{ fontSize: 11, color: "var(--muted)", textTransform: "uppercase", letterSpacing: ".08em", marginBottom: 24 }}>
        Assign roles · viewer → contributor → editor → admin
      </p>

      {err && <p style={{ color: "var(--accent)" }}>{err}</p>}
      {!users && !err && <p className="mono" style={{ color: "var(--muted)", fontSize: 12 }}>Loading…</p>}

      {users && (
        <div style={{ border: "1px solid var(--rule2)" }}>
          <div
            className="mono"
            style={{ display: "grid", gridTemplateColumns: "1fr 130px 140px 120px", gap: 12, padding: "10px 18px", fontSize: 10, textTransform: "uppercase", letterSpacing: ".1em", color: "var(--muted)", borderBottom: "1.5px solid var(--rule)", background: "var(--paper2)" }}
          >
            <span>Member</span>
            <span>Current role</span>
            <span>Change to</span>
            <span>Last login</span>
          </div>
          {users.map((u, i) => (
            <div
              key={u.sub}
              style={{ display: "grid", gridTemplateColumns: "1fr 130px 140px 120px", gap: 12, alignItems: "center", padding: "12px 18px", borderTop: i ? "1px solid var(--rule2)" : "none", background: i % 2 ? "var(--paper2)" : "var(--paper)" }}
            >
              <div>
                <span style={{ fontFamily: "'Zilla Slab',sans-serif", fontWeight: 600, fontSize: 16 }}>{u.name}</span>
                {u.sub === me?.sub && <span className="mono" style={{ fontSize: 9.5, color: "var(--gold)", marginLeft: 8 }}>YOU</span>}
                <div className="mono" style={{ fontSize: 9.5, color: "var(--muted)", marginTop: 2 }}>GICE {u.sub}</div>
              </div>
              <span className="mono" style={{ fontSize: 11, color: u.role === "admin" ? "var(--gold)" : "var(--ink2)" }}>{u.role}</span>
              <select
                value={u.role}
                disabled={busy === u.sub}
                onChange={(e) => change(u, e.target.value as Role)}
                style={{ background: "var(--paper)", color: "var(--ink)", border: "1px solid var(--rule)", padding: "5px 8px", font: "600 11px 'IBM Plex Mono',monospace", borderRadius: 2 }}
              >
                {ROLES.map((r) => (
                  <option key={r} value={r}>
                    {r}
                  </option>
                ))}
              </select>
              <span className="mono" style={{ fontSize: 10.5, color: "var(--muted)" }}>{fmt(u.lastLoginAt)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
